import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";

// Upload file mutation
interface UploadPartFileData {
  partId: string;
  file: File;
  category:
    | "pedigree"
    | "shop_release"
    | "flow_test_report"
    | "dimensional_inspection"
    | "nde_report"
    | "photo";
  force?: boolean;
}

export const useUploadPartFile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      partId,
      file,
      category,
      force,
    }: UploadPartFileData) => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("category", category);
      if (force !== undefined) {
        formData.append("force", force.toString());
      }

      const res = await handleClientMethod(
        getClient().POST("/parts/{id}/file", {
          params: { path: { id: partId } },
          body: formData as any, // hack...
        }),
      );
      return res;
    },
    onSuccess: (_data, variables) => {
      // Invalidate parts list and get-by-id queries
      queryClient.invalidateQueries({ queryKey: ["parts", "list"] });
      queryClient.invalidateQueries({
        queryKey: ["parts", "get-by-id", variables.partId],
      });
      queryClient.invalidateQueries({
        queryKey: ["parts", "files", variables.partId],
      });
    },
  });
};
